import { motion, useMotionValue } from "framer-motion"
import styled from "@emotion/styled"
import hash from "@emotion/hash"

import { useConsole } from "contexts/Console"

import generateComponents, { parseModularBlock } from "utils/generateComponents"
import Image from "components/media/ImageCLD"

export const bgPos = {
  start: `b${hash("bg-start")}`,
  center: `b${hash("bg-center")}`,
  end: `b${hash("bg-end")}`,
}

const Root = styled(motion.div)`
  position: relative;

  .popin-edito & > * {
    width: 100%;
  }
`

const BgFig = styled.figure`
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: -1;
  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  .${bgPos.start} & img {
    object-position: top;
  }
  .${bgPos.center} & img {
    object-position: center;
  }
  .${bgPos.end} & img {
    object-position: bottom;
  }
`

export default function Fragainer({ components, background, background_position }) {
  const console = useConsole()

  const bgs = background ? background.reduce((acc, item) => new Map([...acc, ...Object.entries(item)]), new Map()) : new Map()

  const bgcol = bgs.has("color") ? bgs.get("color").colors.map(({ color, opacity }) => `rgb(${color} / ${opacity})`) : []
  const backgroundColor = useMotionValue(
    bgcol.length === 1 ? bgcol[0] : bgcol.length > 1 ? `linear-gradient(${bgs.get("color").angle ? `${bgs.get("color").angle}deg, ` : ""}${bgcol})` : null
  )
  const bgpos = bgPos[background_position || "center"]

  return (
    <Root className={bgpos} style={{ background: backgroundColor }}>
      {bgs.has("image_cld") ? (
        <BgFig>
          <Image {...bgs.get("image_cld")} sizes='100vw' />
        </BgFig>
      ) : null}
      {components ? generateComponents(parseModularBlock(components, { console }), { console }) : null}
    </Root>
  )
}
